import { render, staticRenderFns } from "./TbConsumptionTerminal.vue?vue&type=template&id=7dcaa972&scoped=true"
import script from "./TbConsumptionTerminal.vue?vue&type=script&lang=js"
export * from "./TbConsumptionTerminal.vue?vue&type=script&lang=js"
import style0 from "./TbConsumptionTerminal.vue?vue&type=style&index=0&id=7dcaa972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcaa972",
  null
  
)

export default component.exports